import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import AlertMessage from '../../../../../../components/AlertMessage';
import EmptyState from '../../../../../../components/EmptyState';
import {
  getComparativeBy,
  changeComparativeType,
  comparativeTypes,
} from '../../../../../../redux/dashboard-completed';
import {
  getDashboardCompletedComparativeBy,
  getDashboardCompletedComparativeByUI,
  getDashboardCompletedPeriodListUI,
} from '../../../../../../redux/selectors';

import ComparativeList from './ComparativeList';
import './styles.css';
import HeatMap from '../HeatMap';
import Filters from '../HeatMap/components/Filters';
import { ValuesInDisplayText, Container, Col } from './styles';
import { Skeleton } from '@mui/material';

// maps

export const comparativeUnits = {
  PERFORMANCE: 'PERFORMANCE',
  WEIGHT: 'WEIGHT',
  VALUE: 'VALUE',
};

export const viewTypes = {
  MAP: 'MAP',
  LIST: 'LIST',
};

export const comparativeUnitsTraskey = {
  [comparativeUnits.PERFORMANCE]: 'Performance',
  [comparativeUnits.WEIGHT]: 'Peso',
  [comparativeUnits.VALUE]: 'Valor',
};

class DashboardCompletedComparative extends Component {
  constructor(props) {
    super(props);

    this.state = {
      comparativeTypeOptions: [
        {
          value: comparativeTypes.REGION,
          label: 'Regiões',
        },
        {
          value: comparativeTypes.UF,
          label: 'Estados',
        },
        {
          value: comparativeTypes.CUSTOMER,
          label: 'Clientes',
        },
      ],
      activeRegions: [],
      activeState: null,

      comparativeUnit: comparativeUnits.PERFORMANCE,
      viewType: viewTypes.MAP,
    };
  }

  componentDidMount() {
    this._changeComparativeType(comparativeTypes.UF);
  }

  componentDidUpdate(prevProps) {
    const {
      data, currentRangeId, comparativeType, ui, periodListUI,
    } =
      this.props;

    if (
      moment(ui.requested).isBefore(periodListUI.received) ||
      (!data &&
        (currentRangeId !== prevProps.currentRangeId ||
          comparativeType !== prevProps.comparativeType))
    ) {
      this._getComparativeBy();
    }
  }

  _setActiveRegions = (activeRegions) => {
    this.setState({ activeRegions });
  };

  _setActiveState = (activeState) => {
    this.setState({ activeState });
  };

  _changeviewType = (viewType) => {
    this.setState({ viewType });
  };

  _getComparativeBy = () => {
    this.props.dispatch(getComparativeBy());
  };

  _changeComparativeType = (comparativeType) => {
    this._setActiveRegions([]);
    this._setActiveState(null);
    this.props.dispatch(changeComparativeType(comparativeType));
  };

  _changeComparativeUnit = (comparativeUnit) => {
    this.setState({ comparativeUnit });
  };

  _getComparativeListValues = () => {
    const { data } = this.props;

    // const data = byStateMock.data.comparative;

    switch (this.state.comparativeUnit) {
      case comparativeUnits.PERFORMANCE:
        return data.map(x => ({
          value: (x.onTimeQty / (x.onTimeQty + x.lateQty)) * 100,
          onTimeQty: x.onTimeQty,
          lateQty: x.lateQty,
          totalQty: x.onTimeQty + x.lateQty,
          text: x.label,
        }));

      case comparativeUnits.VALUE:
        return data.map(x => ({
          value: (x.onTimeValue + x.lateValue) / 1000000,
          text: x.label,
        }));

      default: // case comparativeUnits.WEIGHT:
        return data.map(x => ({
          value: (x.onTimeWeight + x.lateWeight) / 1000,
          text: x.label,
        }));
    }
  };

  _renderComparativeList = () => {
    const {
      data, ui, periodListUI, currentRangeId, comparativeType,
    } =
      this.props;

    const {
      comparativeUnit, activeRegions, activeState, viewType,
    } =
      this.state;


    if (ui.error) {
      return (
        <AlertMessage
          className="DashboardCompletedComparative__error"
          error
          message={ui.error}
          actionText="Tentar novamente"
          onRetry={this._getComparativeBy}
        />
      );
    }

    if (!data || !data[0]) {
      return (
        <EmptyState
          className="DashboardCompletedComparative__empty-state"
          message="Não existem dados para os parâmetros selecionados."
        />
      );
    }

    if (viewType === viewTypes.MAP) {
      return (
        <HeatMap
          data={data}
          ui={ui}
          periodListUI={periodListUI}
          currentRangeId={currentRangeId}
          comparativeType={comparativeType}
          comparativeUnit={comparativeUnit}
          activeRegions={activeRegions}
          setActiveRegions={this._setActiveRegions}
          activeState={activeState}
          setActiveState={this._setActiveState}
        />
      );
    }

    if (viewType === viewTypes.LIST) {
      return (
        <ComparativeList
          unit={comparativeUnit}
          data={this._getComparativeListValues()}
        />
      );
    }
  };

  render() {
    const { comparativeType, ui } = this.props;
    const { comparativeUnit, viewType } = this.state;

    return (
      <div className="DashboardCompletedComparative">
        <Container>
          <Col md9>
            {ui.isFetching ? (
              <Skeleton
                variant="rectangular"
                height="572px"
                animation="wave"
                style={{ borderRadius: 4}}
              />
            ) : (
              <>
                <ValuesInDisplayText>{`${comparativeUnitsTraskey[comparativeUnit]} por localidade`}</ValuesInDisplayText>
                <div className="DashboardCompletedComparative__content">
                  {this._renderComparativeList()}
                </div>
              </>
            )}
          </Col>
          <Col md3>
            {ui.isFetching ? (
              <Skeleton
                variant="rectangular"
                height="572px"
                animation="wave"
                style={{ borderRadius: 4}}
              />
            ) : (
              <Filters
                comparativeUnit={comparativeUnit}
                comparativeUnits={comparativeUnits}
                changeComparativeUnit={this._changeComparativeUnit}
                comparativeType={comparativeType}
                comparativeTypes={comparativeTypes}
                changeComparativeType={this._changeComparativeType}
                viewType={viewType}
                viewTypes={viewTypes}
                changeviewType={this._changeviewType}
              />
            )}
          </Col>
        </Container>
      </div>
    );
  }
}

// redux

const mapStateToProps = state => ({
  data: getDashboardCompletedComparativeBy(state),
  ui: getDashboardCompletedComparativeByUI(state),
  periodListUI: getDashboardCompletedPeriodListUI(state),
  currentRangeId: state.dashboardCompleted.details.currentRangeId,
  comparativeType: state.dashboardCompleted.details.comparativeType,
});

export default connect(mapStateToProps)(DashboardCompletedComparative);
